import { render, staticRenderFns } from "./page-back.vue?vue&type=template&id=f3989ad2&scoped=true"
import script from "./page-back.vue?vue&type=script&lang=ts"
export * from "./page-back.vue?vue&type=script&lang=ts"
import style0 from "./page-back.vue?vue&type=style&index=0&id=f3989ad2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3989ad2",
  null
  
)

export default component.exports